import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import {
  IDutyAcceptPackageParams,
  IDutyAcceptPackage,
  IdutyDeliverParams,
  IPersonOrderItem,
  IDeliverItem,
  IDutyDeliverDownloadReceiptParams,
  IDutyAcceptPackageContractViewItem,
} from '../../types/crowd-source/task-accept-package';

const hostUrl = getHostbaseUrl();

/**
 * 任务管理-接包管理-分页
 * @param params 查询参数
 */
export async function queryDutyAcceptPackagePage(params: IDutyAcceptPackageParams) {
  let data = [] as IDutyAcceptPackage[];
  let total = 0;

  try {
    const { code, context, message } = await Http.post<{data: IDutyAcceptPackage[];total: number}>(
      `${hostUrl}/side/duty/duty-accept-package/page`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IDutyAcceptPackage[]; total: number };

      data = items || [];
      total = all || 0;
      return {
        data,
        total,
      };
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 任务管理-接包管理-下载回单
 * @param params 查询参数
 */
export async function queryDutyAcceptPackageDownloadReceipt(params: IDutyDeliverDownloadReceiptParams) {
  let res = '';

  try {
    const { code, context, message } = await Http.post<string>(
      `${hostUrl}/side/duty/duty-accept-package/download-receipt`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      res = context || '';
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return res;
}

/**
 * 任务管理-接包管理-任务交付
 * @param params 查询参数
 */
export async function queryDutyAcceptPackageDeliver(params: IdutyDeliverParams) {
  let res = {};

  try {
    const { code, context, message } = await Http.post<any>(
      `${hostUrl}/side/duty/duty-accept-package/deliver`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      res = context || {};
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return res;
}

/**
 * 任务管理-接包管理-删除交付记录
 */
export async function queryDutyAcceptPackageRemoveRecord(id: number) {
  let res = {};

  try {
    const { code, context, message } = await Http.get<any>(
      `${hostUrl}/side/duty/duty-accept-package/remove-record`,
      { id },
    );

    if (code === EAxiosResponseCode.Succeed) {
      res = context || {};
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return res;
}

/**
 * 任务管理-接包管理-下载回单-关联订单List
 */
export async function queryPersonOrderList(personIdNumber: string, dutyId: number) {
  let res = [] as IPersonOrderItem[];

  try {
    const { code, context, message } = await Http.get<IPersonOrderItem[]>(
      `${hostUrl}/side/duty/duty-accept-package/person-order-list`,
      {
        personIdNumber,
        dutyId, 
      },
    );

    if (code === EAxiosResponseCode.Succeed) {
      res = context || [] as IPersonOrderItem[];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return res;
}

/**
 * 任务管理-接包管理-任务交付列表
 */
export async function queryDutyAcceptPackageDeliverList(id: number) {
  let res = [] as IDeliverItem[];

  try {
    const { code, context, message } = await Http.get<IDeliverItem[]>(
      `${hostUrl}/side/duty/duty-accept-package/deliver-list`,
      { id },
    );

    if (code === EAxiosResponseCode.Succeed) {
      res = context || [] as IDeliverItem[];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return res;
}

/**
 * 任务管理-接包管理-合同点击查看
 * @param params 查询参数
 */
export async function queryDutyAcceptPackageContractView(dutyId: number, personIdNumber: string) {
  let res = [] as IDutyAcceptPackageContractViewItem[];

  try {
    const { code, context, message } = await Http.get<IDutyAcceptPackageContractViewItem[]>(
      `${hostUrl}/side/duty/duty-accept-package/contract-view`,
      {
        dutyId,
        personIdNumber, 
      },
    );

    if (code === EAxiosResponseCode.Succeed) {
      res = context || [] as IDutyAcceptPackageContractViewItem[];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return res;
}

/**
 * 任务管理-接包管理-批量下载合同
 */
export async function batchDownloadContract(params: IDutyAcceptPackageParams) {
  try {
    const { code, context, message } = await Http.post<string>(
      `${hostUrl}/side/duty/duty-accept-package/batch-download-contract`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return context || '';
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}